import {
	View,
	Text,
	Image,
	SafeAreaView,
	ScrollView,
	TouchableOpacity,
	ActivityIndicator,
} from "react-native";
import React, { useCallback, useLayoutEffect, useState } from "react";
import { useFocusEffect, useNavigation } from "@react-navigation/native";
import StatsCard from "../components/StatsCard";
// foto
import { AvatarImage } from "../assets";
import {
	db,
	getUserFullName,
	getUserId,
	getUserPhotoUrl,
} from "../utils/firebase";
import { userData } from "../state/user";
import { doc, getDoc } from "firebase/firestore";

function extractCounters(submissions, startTimestamp) {
	const seenProblems = new Set();
	const correctCounter = { correct: 0, wrong: 0 };
	const difficultyCounter = {
		"very-easy": 0,
		easy: 0,
		medium: 0,
		hard: 0,
		"very-hard": 0,
	};
	const topicCounter = {
		algebra: 0,
		combinatorics: 0,
		geometry: 0,
		"number-theory": 0,
	};

	for (const submission of submissions) {
		if (
			!seenProblems.has(submission.problem_id) &&
			submission.submitted_at.seconds > startTimestamp
		) {
			seenProblems.add(submission.problem_id);
			if (submission.correct) {
				correctCounter.correct++;
			} else {
				correctCounter.wrong++;
			}
			difficultyCounter[submission.difficulty]++;
			topicCounter[submission.topic]++;
		}
	}
	return {
		correctCounter: correctCounter,
		difficultyCounter: difficultyCounter,
		topicCounter: topicCounter,
	};
}

const Stats = ({}) => {
	const navigation = useNavigation();
	const [selectedPeriod, setSelectedPeriod] = useState<number>(4);

	useLayoutEffect(() => {
		navigation.setOptions({
			headerTitleAlign: "center",
			headerStyle: {
				backgroundColor: "#263238",
			},
			headerTitleStyle: {
				color: "white",
			},
			headerTintColor: "white",
			headerShadowVisible: false,
		});
	}, []);

	const [correctCounter, setCorrectCounter] = useState({
		correct: 0,
		wrong: 0,
	});
	const [difficultyCounter, setDifficultyCounter] = useState({
		"very-easy": 0,
		easy: 0,
		medium: 0,
		hard: 0,
		"very-hard": 0,
	});
	const [topicCounter, setTopicCounter] = useState({
		algebra: 0,
		combinatorics: 0,
		geometry: 0,
		"number-theory": 0,
	});

	const [statsState, setStatsState] = useState("loading"); // "loading", "loaded", "zeroProblems", "error"

	async function updateData({ startTimestamp }) {
		if (!startTimestamp) {
			startTimestamp = 0;
		}
		if (userData.submissions !== null) {
			const counters = extractCounters(
				userData.submissions,
				startTimestamp
			);
			if (
				counters.correctCounter.correct === 0 &&
				counters.correctCounter.wrong === 0
			) {
				setStatsState("zeroProblems");
			} else {
				setCorrectCounter(counters.correctCounter);
				setDifficultyCounter(counters.difficultyCounter);
				setTopicCounter(counters.topicCounter);

				setStatsState("loaded");
			}
		} else {
			async function getUserData() {
				const docRef = doc(db, "users", getUserId());
				const docSnap = await getDoc(docRef);

				if (docSnap.exists()) {
					userData.submissions = docSnap.data().submissions;
					const submissions = docSnap.data().submissions;
					const counters = extractCounters(
						submissions,
						startTimestamp
					);
					if (
						counters.correctCounter.correct === 0 &&
						counters.correctCounter.wrong === 0
					) {
						setStatsState("zeroProblems");
					} else {
						setCorrectCounter(counters.correctCounter);
						setDifficultyCounter(counters.difficultyCounter);
						setTopicCounter(counters.topicCounter);

						setStatsState("loaded");
					}
				} else {
					setStatsState("error");
				}
			}
			try {
				getUserData();
			} catch (error) {
				setStatsState("error");
			}
		}
	}

	useFocusEffect(
		useCallback(() => {
			setStatsState("loading");
			updateData({ startTimestamp: 0 });
		}, [])
	);

	if (statsState === "error") {
		return (
			<SafeAreaView className="flex-1 bg-[#263238]">
				<View className="flex-1 px-2 justify-center w-full max-w-screen-lg mx-auto">
					<Text className="text-white text-xl text-center">
						Si è verificato un errore. Riprova.
					</Text>
				</View>
			</SafeAreaView>
		);
	}

	// if (statsState === "zeroProblems") {
	// 	return (
	// 		<SafeAreaView className="flex-1 bg-[#263238]">
	// 			<View className="flex-1 px-2 justify-center w-full max-w-screen-lg mx-auto">
	// 				<Text className="text-white text-xl text-center">
	// 					Comincia a risolvere problemi per vedere le statistiche!
	// 				</Text>
	// 			</View>
	// 		</SafeAreaView>
	// 	);
	// }

	if (statsState === "loading") {
		return (
			<SafeAreaView className="flex-1 bg-[#263238]">
				<View className="flex-1 px-2 justify-center w-full max-w-screen-lg mx-auto">
					<View className="flex-1 items-center justify-center">
						<ActivityIndicator size={"large"} color="white" />
					</View>
				</View>
			</SafeAreaView>
		);
	}

	return (
		<SafeAreaView className="flex-1 bg-[#263238]">
			<View className="flex-1 px-2 justify-center w-full max-w-screen-lg mx-auto">
				{/* Profilo utente */}
				<View className="flex-row justify-center mx-3 my-3 space-x-8">
					<View className="w-16 h-16 bg-gray-400 rounded-full items-center justify-center shadow-lg">
						<Image
							// source={AvatarImage}
							source={{ uri: getUserPhotoUrl() }}
							style={{ width: 64, height: 64 }}
							className="w-full h-full rounded-full object-cover"
						/>
					</View>
					<View className="justify-center">
						<Text className="text-2xl text-white">
							{getUserFullName()}
						</Text>
					</View>
				</View>
				{/* Periodo storico */}
				<View className="flex-row pt-2 px-2 justify-around items-center bg-[#1E272C] rounded-md">
					{[
						"7 giorni",
						"30 giorni",
						"90 giorni",
						"1 anno",
						"storico",
					].map((period, index) => {
						return (
							<TouchableOpacity
								key={index}
								// className="border-bottom-2 border-white"
								className={`${
									selectedPeriod === index
										? "border-b-2 border-b-white"
										: "border-b-2 border-b-[#1E272C]"
								}`}
								onPress={() => {
									setSelectedPeriod(index);
									const now = new Date().getTime() / 1000;
									updateData({
										startTimestamp: [
											now - 7 * 24 * 60 * 60,
											now - 30 * 24 * 60 * 60,
											now - 90 * 24 * 60 * 60,
											now - 365 * 24 * 60 * 60,
											0,
										][index],
									});
								}}
							>
								<Text
									className={`mb-2 ${
										selectedPeriod === index
											? "text-white"
											: "text-slate-600"
									}`}
								>
									{period}
								</Text>
							</TouchableOpacity>
						);
					})}
				</View>
				{statsState === "zeroProblems" ? (
					<View className="flex-1 px-2 justify-center w-full max-w-screen-lg mx-auto">
						<Text className="text-white text-xl text-center">
							Comincia a risolvere problemi per vedere le
							statistiche!
						</Text>
					</View>
				) : (
					<ScrollView className="flex-1 mb-3">
						<StatsCard
							pieData={[
								{
									x:
										correctCounter.correct === 1
											? "Risposta esatta"
											: "Risposte esatte",
									y: correctCounter.correct,
								},
								{
									x:
										correctCounter.wrong === 1
											? "Risposta errata"
											: "Risposte errate",
									y: correctCounter.wrong,
								},
							]}
							colorPieChart={["#c3e88d", "#f07178"]}
							colorPie={["bg-[#c3e88d]", "bg-[#f07178]"]}
							text="Risposte ai problemi"
						/>
						<StatsCard
							pieData={[
								{
									x: "Algebra",
									y: topicCounter.algebra,
								},
								{
									x: "Combinatoria e logica",
									y: topicCounter.combinatorics,
								},
								{
									x: "Geometria",
									y: topicCounter.geometry,
								},
								{
									x: "Teoria dei numeri",
									y: topicCounter["number-theory"],
								},
							]}
							colorPieChart={[
								"#f78c6c",
								"#009688",
								"#ffcb6b",
								"#c792ea",
							]}
							colorPie={[
								"bg-[#f78c6c]",
								"bg-[#009688]",
								"bg-[#ffcb6b]",
								"bg-[#c792ea]",
							]}
							text="Argomenti dei problemi"
						/>
						<StatsCard
							pieData={[
								{
									x: "Molto facile",
									y: difficultyCounter["very-easy"],
								},
								{
									x: "Facile",
									y: difficultyCounter.easy,
								},
								{
									x: "Medio",
									y: difficultyCounter.medium,
								},
								{
									x: "Difficile",
									y: difficultyCounter.hard,
								},
								{
									x: "Estremo",
									y: difficultyCounter["very-hard"],
								},
							]}
							colorPieChart={[
								"#c3e88d",
								"#93b85d",
								"#f78c6c",
								"#f07178",
								"#ff5370",
							]}
							colorPie={[
								"bg-[#c3e88d]",
								"bg-[#93b85d]",
								"bg-[#f78c6c]",
								"bg-[#f07178]",
								"bg-[#ff5370]",
							]}
							text="Difficoltà dei problemi"
						/>
					</ScrollView>
				)}
			</View>
		</SafeAreaView>
	);
};

export default Stats;
